import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    FotoGaleria: [],
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_FOTO_GALERIAS = 'GET_ALL_FOTO_GALERIAS'
const GET_FOTO_GALERIA_BY_ID = 'GET_FOTO_GALERIA_BY_ID'
const GET_FOTO_GALERIA_BY_ANEXO_UP = 'GET_FOTO_GALERIA_BY_ANEXO_UP'
const POST_FOTO_GALERIA = 'POST_FOTO_GALERIA'
const UPDATE_FOTO_GALERIA = 'UPDATE_FOTO_GALERIA'
const DELETE_FOTO_GALERIA = 'DELETE_FOTO_GALERIA'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllFotoGalerias = createAsyncThunk(
    GET_ALL_FOTO_GALERIAS,
    async () => {
        try {
            const fullUrl = host + `Fi25FotoGaleria/obtenerFotoGaleria`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Caratulas: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getFotoGaleriaById = createAsyncThunk(
    GET_FOTO_GALERIA_BY_ID,
    async (idFotoGaleria) => {
        try {
            const fullUrl = host + `Fi25FotoGaleria/obtenerFotoGaleriaById/${idFotoGaleria}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getFotoGaleriaByanexo = createAsyncThunk(
    GET_FOTO_GALERIA_BY_ANEXO_UP,
    async (id) => {
        try {
            const fullUrl = host + `Fi25FotoGaleria/obtenerFotoGaleriaByanexo/${id}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const insertFotoGaleria = createAsyncThunk(
    POST_FOTO_GALERIA,
    async (data) => {
        try {
            const fullUrl = host + `Fi25FotoGaleria/agregarFotoGaleria`
            const datamain = { data: data.data }
            const imagen = data.imagen
            let formData = new FormData();
            formData.append(0, imagen)
            formData.append('idfi_25anexo', datamain.data.idfi_25anexo)
            formData.append('idseccion', datamain.data.idseccion)
            formData.append('ruta', datamain.data.ruta)
            const resFile = await axios.post(fullUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return 'result'
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateFotoGaleria = createAsyncThunk(
    UPDATE_FOTO_GALERIA,
    async (data) => {
        try {
            const fullUrl = host + `Fi25FotoGaleria/actualizarFotoGaleria`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteFotoGaleria = createAsyncThunk(
    DELETE_FOTO_GALERIA,
    async (idFotoGaleria) => {
        try {
            const fullUrl = host + `Fi25FotoGaleria/eliminarFotoGaleria/${idFotoGaleria}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosFotoGaleriaSlice = createSlice({

    name: 'metodosFotoGaleriaSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllFotoGalerias.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.FotoGaleria = payload.data.data

        },
        [getFotoGaleriaById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.FotoGaleria = payload.data.data
        },
        [getFotoGaleriaByanexo.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.FotoGaleria = payload.data.data
        },
        [insertFotoGaleria.fulfilled]: (state, { payload }) => {
        },

        [updateFotoGaleria.fulfilled]: (state, { payload }) => {

        },
        [deleteFotoGaleria.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosFotoGaleriaSlice.actions
export const FotoGaleriaReducer = metodosFotoGaleriaSlice.reducer